// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* ------------------------------------------------------------------------------------------ */
/* Based on the "Color Tokens" view -------------------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const colors: Styleguide["colors"] = {
    primary: {
        main: "#b12028", // Primary -> Main
        contrast: "#ffffff", // None, look at primary button text color
        light: "#eb232e", // Primary -> Light
        dark: "#7b151c", // Primary -> Dark
    },
    secondary: {
        main: "#6d6e71", // Secondary -> Main
        contrast: "#ffffff", // None, look at secondary button text color
        light: "#c1c1c1", // Secondary -> Light
        dark: "#4c4d4f", // Secondary -> Dark
    },
    tertiary: {
        main: "#221f20", // Tertiary -> Main
        contrast: "#ffffff", // None, look at tertiary button text color
        light: "#213146", // Tertiary -> Light
        dark: "#000000", // Tertiary -> Dark
    },
    common: {
        border: "#c1c1c1", // Border -> Border
        borderLight: "#e6e6e6", // Gray Shades -> Light
        borderDark: "#6d6e71", // Gray Shades -> Main
        accent: "#f5f5f5", // Gray Shades -> Light
        accentContrast: "#6d6e71", // Text Color -> Main
        accentContrastLight: "#6d6e71", // Gray Shades -> Main
        background: "#ffffff", // None, look at website background color
        backgroundContrast: "#6d6e71", // Text Color -> Main
        disabled: "#f5f5f5", // Gray Shades -> Light
        disabledDark: "#bababa", // Gray Shades -> Mid
    },
    text: {
        main: "#6d6e71", // Text Color -> Main
        accent: "#66676b", // Text Color -> Accent
        disabled: "#a8a8a8", // Text Color -> Semi
        link: "#202332", // Primary -> Main
        linkHover: "#b12028", // Primary -> Dark
        linkAlt: "#202332", // Text Color -> Main
        linkAltHover: "#b12028", // Primary -> Main
        input: "#6d6e71", // Text Color -> Main
    },
    success: {
        main: "#238c60", // Alerts/Contrast -> Success
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Success" token
        light: "#f0fdf5", // Alerts/Light -> Success
    },
    warning: {
        main: "#ad5910", // Alerts/Contrast -> Warning
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Warning" token
        light: "#fff8f1", // Alerts/Light -> Warning
    },
    danger: {
        main: "#e00751", // Alerts/Contrast -> Error
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Error" token
        light: "#fff2f4", // Alerts/Light -> Error
    },
    info: {
        main: "#1985c9", // Alerts/Contrast -> Info
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Info" token
        light: "#f0faff", // Alerts/Light -> Info
    },
    neutral: {
        main: "#666666", // None
        contrast: "#ffffff", // None
        light: "#e0e0e0", // None
    },
    invert: {
        main: "#ffffff", // None
        contrast: "#b12028", // Primary -> Main
        hover: "#7b151c", // Primary -> Dark
        dark: "#ffffff", // None
    },
    placeholder: {
        main: "#a8a8a8", // Text Color -> Accent
        disabled: "#bababa", // Gray Shades -> Mid
    },
    button: {
        disabled: {
            main: "#bababa", // Gray Shades -> Mid
            contrast: "#ffffff", // Black & White -> White
        },
    },
    header: {
        main: "#ffffff", // None, look at header background color
        contrast: "#6d6e71", // Text Color -> Main
        hover: "#6d6e71", // Primary -> Dark
        accent: "#b12028", // Primary -> Main
        accentHover: "#b12028", // Primary -> Dark
        accentContrast: "#ffffff", // None, should match "primary.contrast"
        accentDark: "#202332", // Store Custom Code
    },
    menu: {
        mainNavigation: {
            main: "#ffffff", // None, look at main navigation background color
            contrast: "#6d6e71", // Text Color -> Main
            hover: "#b12028", // Primary -> Main
            underline: "#b12028", // Primary -> Main
            accent: "#b12028", // Primary -> Main
            accentContrast: "#ffffff", // None, should match "primary.contrast"
            accentHover: "#b12028", // Primary -> Main
            separator: "#e6e6e6", // Border -> Border
            border: "#e6e6e6", // Border -> Border
        },
        secondaryNavigation: {
            main: "#f5f5f5", // Primary -> Dark
            contrast: "#6d6e71", // None, should match "primary.contrast"
            hover: "#6d6e71", // None, should match "primary.contrast"
        },
    },
    footer: {
        main: "#b12028", // Gray Shades -> Light
        contrast: "#ffffff", // Text Color -> Main
        alt: "#7b151c", // Primary -> Dark
        altContrast: "#ffffff", // None, should match "primary.contrast"
    },
    swatch: {
        main: "#c1c1c1", // Border -> Border
        contrast: "#6d6e71", // Text Color -> Main
        hover: "#b12028", // Primary -> Main
        selected: "#b12028", // Primary -> Main
        selectedHover: "#7b151c", // Primary -> Dark
    },
};

export default colors;
